<template lang="pug">
div.px-1
  div.d-flex.align-center
    slot(name="title")
    v-spacer
    v-card.round-xl.px-2.py-1(v-if="isHqAndHasCompanySelected || !isHq" outlined)
      y-checkbox.mb-n2(v-model="overrideAppt" @change="updateOverride(overrideAppt)")
        template(#label)
          div.d-flex.align-center
            .text-sm.neutral700--text.mt-1 Override
            v-tooltip(top color="black")
              template(#activator="{ on, attrs }")
                v-icon.ml-2(color="neutral500" size="20" v-bind="attrs" v-on="on" style="margin-top: 2px;") $yzi-info-square
              div.py-1
                div.text-xs.font-semibold Override booking
                div.text-xs Ignore the booking rule and allow last-minute bookings
  v-form(ref="form")
    .mt-4(v-if="isHq")
      div.text-sm.font-semibold.neutral500--text.mb-2 Branch
      company-dropdown-single-select(:disabled="!!appointment")
    div(v-if="isHqAndHasCompanySelected || !isHq")
      template(v-if="showService")
        div.text-sm.font-semibold.neutral500--text.mt-4.mb-2 {{ $t('service_type') }}
        //- y-select.mt-2(v-model="form.service" :items="services" item-text="name" item-value="id" :placeholder="$t('select_service_type')" :rules="rules.not_empty_select" :loading="isFetchingService" :disabled="checkType" @change="fetchProviders(form.service)")
        v-autocomplete.mt-2.round-xl.icon-height(v-model="form.service" :items="services" item-text="name" item-value="id" :placeholder="$t('select_service_type')" :rules="rules.not_empty_select" :loading="isFetchingService" :disabled="checkType" outlined dense height="48" hide-details="auto" no-data-text="No service found" append-icon="$yzi-chevron-down" @change="fetchProviders(form.service)")
      template(v-if="showProvider")
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('doctor') }}
        //- y-select.mt-2(v-model="form.provider" :items="providers" item-text="name" item-value="id" :placeholder="$t('select_doctor')" :rules="rules.not_empty_select" :loading="isFetchingProvider" :disabled="checkType" no-data-text="No provider available" @change="clearDateTime(form.provider)")
        v-autocomplete.mt-2.round-xl.icon-height(v-model="form.provider" :items="providers" item-text="name" item-value="id" :placeholder="$t('select_doctor')" :rules="rules.not_empty_select" :loading="isFetchingProvider" :disabled="checkType" no-data-text="No provider available" outlined dense height="48" append-icon="$yzi-chevron-down" hide-details="auto" @change="clearDateTime")
      template(v-if="showDateTime")
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('appointment_date') }}
        y-dialog(v-model='showPicker' width='380px' persistent content-class="round-3xl")
          template(v-slot:activator='{ on }')
            v-text-field.text-sm.mt-2.round-xl(v-model="selectedDateField" :placeholder="$t('select_appointment_date')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" v-on="on" readonly :disabled="!form.provider || !form.service" :loading="isFetchingDates")
              template(v-slot:append)
                eva-icon(name="calendar-outline" fill="#848484")
          v-card
            v-card-text.px-2.pt-2.pb-0
              div.d-flex.justify-center.align-center(v-if="isFetchingDates" style="height: 380px;")
                v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
              yc-date-picker(v-else :parentDate.sync="selectedDate" color="info" :allowedDates="unavailableDateList" :minDate="getMinDate()" :parentPickerDate.sync="pickerDate")
            v-card-actions.px-4.pb-4
              v-row(no-gutters)
                v-col.pr-2
                  v-btn.button-sm(color="neutral700" block dark outlined depressed @click="closeDate") {{ $t('cancel') }}
                v-col.pl-2
                  v-btn.button-sm(color="neutral700" block depressed :dark="Boolean(selectedDate)" :disabled="!selectedDate" @click="pickDate(form.service, form.provider, selectedDate)") {{ $t('select') }}

        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('available_time') }}
        y-select.mt-2(v-model="form.time" :items="times" item-text="text" item-value="value" :placeholder="$t('select_available_time')" :rules="rules.not_empty_select" :loading="isFetchingTimes" no-data-text="No timeslot available")
      div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('notes') }}
      v-textarea.text-sm.mt-2.round-xl(v-model="form.remarks" :placeholder="$t('notes_optional')" outlined rows="3" hide-details="auto")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import CompanyDropdownSingleSelect from '@/components/hq/custom/CompanyDropdownSingleSelect.vue'

export default {
  name: 'AppointmentDetails',
  components: { CompanyDropdownSingleSelect },
  props: ['appointment'],
  data () {
    return {
      isFetchingService: false,
      isFetchingProvider: false,
      isFetchingDates: false,
      isFetchingTimes: false,
      showPicker: false,
      overrideAppt: false,
      form: {},
      services: [],
      providers: [],
      unavailableDates: [],
      times: [],
      selectedDate: null,
      selectedDateField: null,
      selectedService: null,
      pickerDate: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    detailsData () {
      return {
        form: this.form,
        service: this.selectedService,
        override: this.overrideAppt
      }
    },
    checkType () {
      let readonly = false
      if (this.appointment && this.appointment.type !== 'regular') {
        return readonly = true
      }
      return readonly
    },
    showService () {
      let show = true
      if (this.appointment && ((this.appointment.services && this.appointment.services.length > 1) || this.appointment.type === 'combo')) {
        return show = false
      }
      return show
    },
    showProvider () {
      let show = true
      if (this.appointment && this.appointment.type === 'combo') {
        return show = false
      }
      return show
    },
    showDateTime () {
      let show = true
      if (this.appointment && (this.appointment.type === 'combo' || this.appointment.services.length > 1)) {
        return show = false
      }
      return show
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany?.slug : this.company?.slug
    },
    isHqAndHasCompanySelected () {
      return this.isHq && !!this.hqSelectedCompany
    }
  },
  watch: {
    detailsData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempAppointment', val)
      } 
    },
    pickerDate (val) {
      this.fetchUnavailableDates(val)
    },
    hqSelectedCompany (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleResetData()
        this.fetchServices()
        this.$refs.form.resetValidation()
      }
    }
  },
  mounted () {
    if (this.appointment) {
      this.setData()
    } else {
      this.fetchServices()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.form = {
        service: this.appointment.service.id,
        provider: this.appointment.provider.id,
        date: this.appointment.date || null,
        time: this.appointment.time || null,
        remarks: this.appointment.lead.remarks
      }
      this.selectedDateField = this.form.date ? this.$options.filters.humanizeDate(this.form.date) : null
      this.isFetchingService = true
      this.isFetchingProvider = true
      this.$axios.get(`/clinics/${this.companySlug}/services?page_size=-1&fields=id,name`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.services = resp.data.results
            if (!this.services.find(f => f.id === this.form.service)) {
              this.services.unshift({ name: this.appointment.service.name, id: this.appointment.service.id })
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingService = false
        })
      this.$axios.get(`/clinics/${this.companySlug}/providers?page_size=-1&services=${this.form.service}&status=active&fields=id,name`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.providers = resp.data.results
            if (!this.providers.find(f => f.id === this.form.provider)) {
              this.providers.unshift({ name: this.appointment.provider.name, id: this.appointment.provider.id })
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingProvider = false
        })
      if (this.form.date) {
        this.isFetchingTimes = true
        this.$axios.get(`/clinics/${this.companySlug}/providers/${this.form.provider}/available_times?service=${this.form.service}&date=${this.form.date}`)
          .then(resp => {
            this.times = resp.data.times.map(m => { return { text: this.$options.filters.displayTime2(m), value: m }})
            if (!this.times.find(f => f.value === this.form.time)) {
                this.times.unshift({ text: this.$options.filters.displayTime2(this.appointment.time), value: this.appointment.time })
              }
          })
          .catch(() => {})
          .finally(() => {
            this.isFetchingTimes = false
          })
      }
    },
    fetchServices () {
      this.isFetchingService = true
      this.$axios.get(`/clinics/${this.companySlug}/services?page_size=-1&fields=id,name&booking_enabled=true`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.services = resp.data.results
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingService = false
        })
    },
    fetchServicesInfo (val) {
      this.$axios.get(`/clinics/${this.companySlug}/services/${val}`)
        .then(resp => {
          this.selectedService = resp.data
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
    },
    fetchProviders (service) {
      this.isFetchingProvider = true
      this.providers = []
      this.unavailableDates = []
      this.times = []
      !this.form.provider || this.$set(this.form, 'provider', null)
      !this.form.date || this.$set(this.form, 'date', null)
      !this.form.time || this.$set(this.form, 'time', null)
      this.selectedDate = null
      this.selectedDateField = null
      if (!service) {
        this.isFetchingProvider = false
        return
      }
      this.fetchServicesInfo(service)
      this.$axios.get(`/clinics/${this.companySlug}/providers?page_size=-1&services=${service}&status=active&fields=id,name`)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.providers = resp.data.results
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingProvider = false
        })
    },
    fetchUnavailableDates (yearMonth) {
      this.isFetchingDates = true
      let params = {
        services: this.form.service,
        provider: this.form.provider
      }
      if (yearMonth) {
        params.year = yearMonth.substr(0, 4),
        params.month = yearMonth.substr(-2)
      }
      if (this.overrideAppt) {
        params.ignore_rules = 'service_prep_time'
      }
      this.$axios.get(`/clinics/${this.companySlug}/block_dates`, { params })
        .then(resp => {
          this.unavailableDates = resp.data
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingDates = false
        })
    },
    fetchTimes (service, provider, date) {
      this.isFetchingTimes = true
      !this.form.time || this.$set(this.form, 'time', null)
      let params = { service, date }
      if (this.overrideAppt) {
        params.ignore_rules = 'service_prep_time'
      }
      this.$axios.get(`/clinics/${this.companySlug}/providers/${provider}/available_times`, { params })
        .then(resp => {
          this.times = resp.data.times.map(m => { return { text: this.$options.filters.displayTime2(m), value: m }})
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    unavailableDateList (val) {
      if (this.unavailableDates.includes(val)) {
        return false
      }
      return true
    },
    pickDate (service, provider, date) {
      this.selectedDateField = this.$options.filters.humanizeDate(date)
      this.$set(this.form, 'date', date)
      this.showPicker = false
      this.fetchTimes(service, provider, date)
    },
    closeDate () {
      this.showPicker = false
    },
    clearDateTime () {
      this.times = []
      !this.form.date || this.$set(this.form, 'date', null)
      !this.form.time || this.$set(this.form, 'time', null)
      this.selectedDate = null
      this.selectedDateField = null
      this.fetchUnavailableDates(this.pickerDate)
    },
    getMinDate () {
      if (this.overrideAppt) {
        return this.getTodayDate()
      } else if (this.selectedService && (this.selectedService.preparation_time_unit === 'days' || this.selectedService.preparation_time_unit === 'weeks' || this.selectedService.preparation_time_unit === 'months')) {
        let days = 0
        let weeks = 0
        let months = 0
        if (this.selectedService.preparation_time_unit === 'days') {
          days = this.selectedService.preparation_time_value
        } else if (this.selectedService.preparation_time_unit === 'weeks') {
          weeks = this.selectedService.preparation_time_value
        } else if (this.selectedService.preparation_time_unit === 'months') {
          months = this.selectedService.preparation_time_value
        }
        let date = DateTime.local()
        date = date.plus({days: days, weeks: weeks, months: months})
        return date.toFormat('yyyy-MM-dd')
      } else {
        return this.getTodayDate()
      }
    },
    updateOverride (override) {
      if (override) {
        this.showMessage(['info', `This override function will ignore the 'booking before X time' rule, allowing last-minute bookings.`])
      }
      if (this.form.service && this.form.provider) {
        this.clearDateTime()
      }
    },
    getTodayDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`;
    },
    handleResetData() {
      this.form = {}
      this.services = []
      this.providers = []
      this.unavailableDates = []
      this.times = []
      this.selectedDate = null
      this.selectedDateField = null
      this.selectedService = null
      this.overrideAppt = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .icon-height .v-input__control .v-input__append-inner .v-input__icon {
    height: 32px;
  }
}
</style>